import React, { useEffect, useRef } from "react";
import "../styles/main.css";
const images = [
  {
    src: "./assets/v1web.png",
    mobileSrc: "./assets/v1mob.png",
    alt: "",
    title: "",
    description: "",
  },
  {
    src: "./assets/v2web.png",
    mobileSrc: "./assets/v2mob.png",
    alt: "",
    title: "",
    description: "",
  },
  // {
  //   src: "./assets/v3web.png",
  //   mobileSrc: "./assets/v3mob.png",
  //   alt: "",
  //   title: "",
  //   description: "",
  // }
];

const INTERVAL = 5000; // ← change this ONE number to adjust timing

const Home = () => {
  const carouselRef = useRef(null);
  const instanceRef = useRef(null);

  useEffect(() => {
    const init = () => {
      const el = carouselRef.current;
      if (!el || !window.bootstrap) return;

      // Kill any existing instance first
      const old = window.bootstrap.Carousel.getInstance(el);
      if (old) old.dispose();

      // Create exactly ONE instance with JS only — no data-bs-* attributes
      instanceRef.current = new window.bootstrap.Carousel(el, {
        interval: INTERVAL,
        ride: "carousel",
        wrap: true,
        touch: true,
        pause: false,
      });

      instanceRef.current.cycle();
    };

    if (window.bootstrap) {
      init();
    } else {
      const timer = setInterval(() => {
        if (window.bootstrap) { clearInterval(timer); init(); }
      }, 100);
      return () => clearInterval(timer);
    }

    return () => {
      if (instanceRef.current) {
        instanceRef.current.dispose();
        instanceRef.current = null;
      }
    };
  }, []);

  return (
    <>
      {/*
        NO data-bs-ride, data-bs-interval, or data-bs-pause here.
        Mixing data attributes + JS config causes random scroll timing.
        Everything is controlled by the JS instance above only.
      */}
      <div ref={carouselRef} id="homeCarousel" className="carousel slide carousel-fade vk-carousel">
        <div className="carousel-inner vk-inner">
          {images.map((img, idx) => (
            <div key={idx} className={`carousel-item${idx === 0 ? " active" : ""}`}>
              <picture>
                <source srcSet={img.mobileSrc} media="(max-width: 768px)" />
                <img
                  src={img.src}
                  className="vk-img"
                  alt={img.alt}
                  loading={idx === 0 ? "eager" : "lazy"}
                />
              </picture>

              {(img.title || img.description) && (
                <div className="vk-caption">
                  {img.title && <h5 className="vk-title">{img.title}</h5>}
                  {img.description && <p className="vk-desc">{img.description}</p>}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="carousel-indicators vk-dots">
          {images.map((_, idx) => (
            <button
              key={idx}
              type="button"
              data-bs-target="#homeCarousel"
              data-bs-slide-to={idx}
              className={idx === 0 ? "active" : ""}
              aria-label={`Slide ${idx + 1}`}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default Home;